import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
let store = new Vuex.Store({
  // 1. state
  state: {
    roleObj: {}
  },
  mutations: {
    setRoleObj(state, arr) {
      let obj = {}
      this.commit('mapRole', {arr, obj})
    },
    mapRole (state, arg) {
      let {arr, obj} = arg
      arr.map((item, index) => {
        let o = {}
        if (item.parent_id) {
          o['parentId'] = item.parent_id
          // state.roleObj[item.id] = {parentId: item.parent_id}
        }
        if (item.children && item.children.length) {
          o['isParent'] = true
          // state.roleObj[item.id] = {isParent: true}
          this.commit('mapRole', {arr: item.children, obj})
        }
        state.roleObj[item.id] = o
      })
    }
  }
});

export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js